export const INPUT_DEBOUNCE_TIME = 1000

export const DEEPL_LOCALE = {
    fr_FR: 'FR',
    en_UK: 'EN-GB',
    en_US: 'EN-US',
    es_ES: 'ES',
    it_IT: 'IT',
    de_DE: 'DE',
}
export const LOCALE = {
    fr_FR: 'French',
    fr_CA: 'Canadian French',
    en_UK: 'British English',
    en_US: 'American English',
    es_ES: 'Spanish',
    it_IT: 'Italian',
    de_DE: 'German',
}
export const FLAGS = {
    fr_FR: 'flags/FR.png',
    fr_CA: 'flags/CA.png',
    en_UK: 'flags/UK.png',
    en_US: 'flags/US.png',
    es_ES: 'flags/ES.png',
    it_IT: 'flags/IT.png',
    de_DE: 'flags/DE.png',
}
export const ARTICLE_STATUS_ARRAY = [
    { id: '0', label: 'Text', icon: 'fas fa-file-alt' }, // 0: incomplete, 1, complete
    { id: '1', label: 'Products', icon: 'fab fa-amazon' },
    { id: '2', label: 'Translation', icon: 'fad fa-language' },
    { id: '3', label: 'Image Captions Translation', icon: 'fas fa-file-image' },
    { id: '4', label: 'Images', icon: 'fas fa-image' },
    { id: '5', label: 'Image Links', icon: 'fas fa-external-link' },
    { id: '6', label: 'Text Links', icon: 'fas fa-link' },
    { id: '7', label: 'Proof-read', icon: 'fas fa-glasses' },
]
export const FRONT_STORE_ARRAY = [
    {
        url: 'amazon.fr',
        locale: 'fr_FR',
        external_id_manual_search: (external_id, tracking_id) =>
            `https://partenaires.amazon.fr/home/productlinks/search?tracking_id=${tracking_id}&category=all&keywords=${external_id}&sortby=`,
    },
    {
        url: 'amazon.ca',
        locale: 'fr_CA',
        external_id_manual_search: (external_id, tracking_id) =>
            `https://associates.amazon.ca/home/productlinks/search?tracking_id=${tracking_id}&category=all&keywords=${external_id}&sortby=`,
    },
    {
        url: 'amazon.de',
        locale: 'de_DE',
        external_id_manual_search: (external_id, tracking_id) =>
            `https://affiliate-program.amazon.de/home/productlinks/search?tracking_id=${tracking_id}&category=all&keywords=${external_id}&sortby=`,
    },
    {
        url: 'amazon.it',
        locale: 'it_IT',
        external_id_manual_search: (external_id, tracking_id) =>
            `https://affiliate-program.amazon.it/home/productlinks/search?tracking_id=${tracking_id}&category=all&keywords=${external_id}&sortby=`,
    },
    {
        url: 'amazon.es',
        locale: 'es_ES',
        external_id_manual_search: (external_id, tracking_id) =>
            `https://affiliate-program.amazon.es/home/productlinks/search?tracking_id=${tracking_id}&category=all&keywords=${external_id}&sortby=`,
    },
    {
        url: 'amazon.co.uk',
        locale: 'en_UK',
        external_id_manual_search: (external_id, tracking_id) =>
            `https://affiliate-program.amazon.co.uk/home/productlinks/search?tracking_id=${tracking_id}&category=all&keywords=${external_id}&sortby=`,
    },
    {
        url: 'amazon.com',
        locale: 'en_US',
        external_id_manual_search: (external_id, tracking_id) =>
            `https://affiliate-program.amazon.com/home/productlinks/search?tracking_id=${tracking_id}&category=all&keywords=${external_id}&sortby=`,
    },
]

export const ENABLED_API_LOCALE_ARRAY = ['fr_FR', 'es_ES', 'en_UK', 'en_US']
